/* eslint-disable import/no-extraneous-dependencies */
import { call, put, takeLatest } from 'redux-saga/effects';

import { axiosMicro } from '~/services';
import * as Actions from './actions';

function* getAllProducts({ payload }) {
  try {
    const response = yield call(
      typeof payload === 'string'
        ? () => axiosMicro.get(`/products?${payload}`)
        : () => axiosMicro.get('/products', { params: payload }),
    );
    yield put(Actions.getAllProductsSuccess({ ...response.data, append: payload?.append }));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.getAllProductsFailure(messages));
    }
  }
}

function* getDetailProduct({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(`/products?id=${payload.id}&include=categories,units`));
    if (response.data?.data?.length > 0) {
      yield put(Actions.getDetailProductSuccess(response.data.data[0]));
    } else if (response.data && !response.data.data) {
      yield put(Actions.getDetailProductSuccess(response.data));
    } else {
      yield put(Actions.getDetailProductFailure({ message: 'Product not found' }));
    }
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.getDetailProductFailure(messages));
    }
  }
}

function* getListProducts({ payload }) {
  try {
    const response = yield call(
      typeof payload === 'string'
        ? () => axiosMicro.get(`/products/list?${payload}`)
        : () => axiosMicro.get('/products/list', { params: payload }),
    );
    yield put(Actions.getListProductsSuccess(response.data));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.getListProductsFailure(messages));
    }
  }
}

function* createProduct({ payload }) {
  try {
    const response = yield call(() => axiosMicro.post('/products', payload));
    yield put(Actions.createProductSuccess(response.data));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.createProductFailure(messages));
    }
  }
}

function* updateProduct({ payload }) {
  try {
    const response = yield call(() => axiosMicro.patch(`/products/${payload.id}`, payload.body));
    yield put(Actions.updateProductSuccess(response.data));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.updateProductFailure(messages));
    }
  }
}

function* deleteProduct({ payload }) {
  try {
    yield call(() => axiosMicro.delete(`/products/${payload}`));
    yield put(Actions.deleteProductSuccess(payload));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.deleteProductFailure(messages));
    }
  }
}

function* getListCategories({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get('/categories', { params: payload }));
    yield put(Actions.getListCategoriesSuccess({ ...response.data, append: payload?.append }));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.getListCategoriesFailure(messages));
    }
  }
}

function* getProductsScanner({ payload }) {
  try {
    const response = yield call(
      typeof payload === 'string'
        ? () => axiosMicro.get(`/products?${payload}`)
        : () => axiosMicro.get('/products', { params: payload }),
    );
    yield put(Actions.getProductsScannerSuccess(response.data));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.getProductsScannerFailure(messages));
    }
  }
}

function* importFileExcelProduct({ payload }) {
  try {
    const response = yield call(() => axiosMicro.post('/products/import', payload));
    yield put(Actions.importFileExcelProductSuccess(response.data));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.importFileExcelProductFailure(messages));
    }
  }
}

function* searchProducts({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get('/products/list', {
      params: payload,
    }));
    yield put(Actions.searchProductsSuccess(response.data));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.searchProductsFailure(messages));
    }
  }
}

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(Actions.getAllProductsRequest, getAllProducts);
  yield takeLatest(Actions.getDetailProductRequest, getDetailProduct);
  yield takeLatest(Actions.createProductRequest, createProduct);
  yield takeLatest(Actions.updateProductRequest, updateProduct);
  yield takeLatest(Actions.deleteProductRequest, deleteProduct);
  yield takeLatest(Actions.getListCategoriesRequest, getListCategories);
  yield takeLatest(Actions.getListProductsRequest, getListProducts);
  yield takeLatest(Actions.getProductsScannerRequest, getProductsScanner);
  yield takeLatest(Actions.importFileExcelProductRequest, importFileExcelProduct);
  yield takeLatest(Actions.searchProductsRequest, searchProducts);
}
